export default "__VITE_ASSET__Dx8YJB7e__"